import { requireAuth } from '@/router/helpers';

export default [
  // Collaboration (Questions List)
  {
    path: '/collaboration',
    name: 'Collaboration',
    component: () => import('@/views/Collaboration/'),
    beforeEnter: requireAuth,
  },

  {
    path: '/collaboration/:tabFilter',
    name: 'CollaborationFilter',
    component: () => import('@/views/Collaboration/'),
    beforeEnter: requireAuth,
  },

  // Question -> Create
  {
    path: '/collaboration/question/create',
    name: 'QuestionCreate',
    components: {
      default: () => import('@/views/Collaboration/'),
      panel: () => import('@/views/Collaboration/QuestionCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Question -> Edit
  {
    path: '/collaboration/question/:questionId/edit',
    name: 'QuestionEdit',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/QuestionCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Question -> Invite
  {
    path: '/collaboration/question/:questionId/invite',
    name: 'QuestionInvite',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/QuestionInvite'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Question -> Responses
  {
    path: '/collaboration/question/:questionId/responses',
    name: 'QuestionResponses',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/QuestionResponses'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Question -> Preview
  {
    path: '/collaboration/question/:questionId',
    name: 'CollaborationQuestion',
    component: () => import('@/views/Collaboration/QuestionShow'),
    beforeEnter: requireAuth,
  },

  // Idea -> edit
  {
    path: '/collaboration/question/:questionId/idea/:ideaId/edit',
    name: 'IdeaEdit',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/IdeaSubmit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Idea -> submit (testing)
  {
    path: '/collaboration/question/:questionId/idea/add',
    name: 'IdeaSubmit',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/IdeaSubmit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Idea -> Preview
  {
    path: '/collaboration/question/:questionId/idea/:ideaId',
    name: 'CollaborationIdea',
    components: {
      default: () => import('@/views/Collaboration/QuestionShow'),
      panel: () => import('@/views/Collaboration/IdeaView'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      whiteBg: true
    },
  },
];
